import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./WarehouseManagementSoftware.css";

export default function WarehouseManagementSoftware() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: true });
  }, []);

  const features = [
    { icon: "🏬", title: "Multi-Warehouse Control" },
    { icon: "📦", title: "Stock Tracking System" },
    { icon: "📊", title: "Real-Time Analytics" },
    { icon: "🚚", title: "Dispatch & Logistics" },
    { icon: "🧾", title: "Purchase & Sales Management" },
    { icon: "🔐", title: "Role-Based Access Control" },
  ];

  const benefits = [
    { icon: "⚡", title: "Faster Warehouse Operations" },
    { icon: "📉", title: "Reduce Stock Errors" },
    { icon: "📈", title: "Improve Efficiency" },
    { icon: "💰", title: "Reduce Operational Cost" },
  ];

  const industries = [
    "Warehouses",
    "Distribution Centers",
    "Retail Chains",
    "E-Commerce Businesses",
    "Pharmaceutical Storage",
    "Wholesale Businesses",
  ];

  const faqs = [
    {
      q: "What is warehouse management software?",
      a: "It is a system that helps manage stock, shipments, inventory movement, and warehouse operations in real-time.",
    },
    {
      q: "Does it support multi-warehouse?",
      a: "Yes, it supports multiple warehouse locations with centralized control.",
    },
  ];

  return (
    <div className="warehouse-page">
      {/* HERO */}
      <section className="hero" data-aos="fade-up">
        <h1>
          Warehouse Management <span>Software</span>
        </h1>

        <p>
          Advanced <b>ERP, Inventory & Logistics System</b> designed for
          warehouses, distribution centers, and retail supply chains to manage
          stock, dispatch, and operations efficiently.
        </p>
      </section>

      {/* INTRO */}
      <section className="intro" data-aos="fade-up">
        <p className="gradient-text">
          A powerful warehouse management system that automates inventory flow,
          improves stock accuracy, and streamlines logistics operations for
          modern businesses using ERP and POS integration.
        </p>
      </section>

      {/* FEATURES */}
      <section className="section">
        <h2 data-aos="fade-up">Features</h2>

        <div className="grid">
          {features.map((f, i) => (
            <div className="card" key={i} data-aos="zoom-in">
              <div className="icon">{f.icon}</div>
              <h3>{f.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* BENEFITS */}
      <section className="section">
        <h2 data-aos="fade-up">Benefits</h2>

        <div className="grid">
          {benefits.map((b, i) => (
            <div className="card" key={i} data-aos="fade-up">
              <div className="icon">{b.icon}</div>
              <h3>{b.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="section">
        <h2 data-aos="fade-up">Industries</h2>

        <div className="industry-grid">
          {industries.map((item, i) => (
            <div className="industry-box" key={i} data-aos="zoom-in">
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <h2 data-aos="fade-up">FAQs</h2>

        <div className="faq">
          {faqs.map((f, i) => (
            <div className="faq-item" key={i} data-aos="fade-up">
              <h4>{f.q}</h4>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta" data-aos="zoom-in">
        <h2>Optimize Your Warehouse Today</h2>
        <p>
          Get a powerful ERP + Inventory + Logistics system built for scalable
          warehouse operations.
        </p>

        <a href="/contact" className="btn">
          Get Free Consultation
        </a>
      </section>
    </div>
  );
}
